import React from 'react';

const SECTION_THEMES = {
    patients: 'indigo',
    roi: 'rose',
    'appointments-ratio': 'orange',
    email: 'green',
    sms: 'cyan',
    campaigns: 'violet',
};

function DashboardSectionNav({ sections, activeSection, onSectionChange }) {
    return (
        <nav className="dashboard-section-nav" aria-label="Dashboard sections">
            <div className="dashboard-section-nav__track" role="tablist">
                {sections.map((section) => {
                    const theme = SECTION_THEMES[section.id] || 'primary';
                    const isActive = activeSection === section.id;

                    return (
                        <button
                            key={section.id}
                            type="button"
                            role="tab"
                            id={`dashboard-tab-${section.id}`}
                            aria-selected={isActive}
                            aria-controls={`dashboard-panel-${section.id}`}
                            className={`dashboard-section-nav__pill dashboard-section-nav__pill--${theme} ${
                                isActive ? 'is-active' : ''
                            }`}
                            onClick={() => onSectionChange(section.id)}
                        >
                            <i className={`bi ${section.icon}`} aria-hidden="true" />
                            <span>{section.title}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}

export default DashboardSectionNav;
